import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getGameServerMap, getChannelMap } from "@/utils/dictionary";
import serverList from "@/components/serverList/serverOptions.vue";
import DataOptions from "@/components/timeList/dataOptions.vue";
import infoList from "@/mixins/infoList";
import FeedBackComp from './components/feedBackComp.vue';
import { getSuggestList } from "@/api/data";
export default {
  name: "deedBackPeply",
  components: {
    DataOptions: DataOptions,
    FeedBackComp: FeedBackComp,
    serverList: serverList
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSuggestList,
      searchInfo: {},
      replyList: {
        1: "未回复",
        2: "已忽略",
        3: "已回复"
      },
      serverList: {},
      channelMap: {},
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      replyTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      dialogFormVisible: false,
      ID: 0,
      form: {}
    };
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var columnIndex = _ref.columnIndex;
      if (columnIndex === 6) {
        return "colStyle";
      } else {
        return "notcolStyle";
      }
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverList = _context.sent;
              _context.next = 5;
              return getChannelMap();
            case 5:
              _this.channelMap = _context.sent;
              _this.searchEvent();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    searchEvent: function searchEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.start_time = _this2.formData[0];
              _this2.searchInfo.end_time = _this2.formData[1];
              _this2.searchInfo.reply_start_time = _this2.replyTime[0];
              _this2.searchInfo.reply_end_time = _this2.replyTime[1];
              _context2.next = 6;
              return _this2.getTableData();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkBtn: function checkBtn(e) {
      this.form = e;
      this.dialogFormVisible = true;
    },
    deleteBtn: function deleteBtn(e) {
      console.log("e", e);
      //调用接口删除
    },
    backBtn: function backBtn(e) {
      this.dialogFormVisible = e;
    }
  },
  created: function created() {
    this.init();
  }
};